import { AmericanRouletteDefinition } from './AmericanRouletteDefinition';

export const getRouletteSectorLabel = (value: number): string =>
    // Use American roulette collection because it has full set (incl. 00)
    AmericanRouletteDefinition.insideBetsMap[value].valueText ||
    AmericanRouletteDefinition.insideBetsMap[value].value.toString();
